import React from 'react';
import { Checkbox } from 'antd';
import LicensesTableActionButtons from '../LicensesTableActionButtons';
import { getFilterOptions, sortAssignedRows } from '../services/tableService';
import { isUserAdminTier } from '@shared/services/checkUserTierService';
import { PAGE_MODE } from '../../../constants/pageModeTypes';
import SUPPLEMENTAL_ROLE from '../../../../../constants/supplemental-Roles';

const COLUMN_FIELDS = {
  EMAIL: {
    TITLE: 'Email',
    DATA_INDEXE: 'Email'
  },
  NAME: {
    TITLE: 'Name',
    DATA_INDEXE: 'Name'
  },
  ROLE: {
    TITLE: 'Role',
    DATA_INDEXE: 'RoleDisplayName'
  },
  SUPER_USER: {
    TITLE: 'Super User',
    DATA_INDEXE: 'IsSuperUser'
  },
  ORGS: {
    TITLE: 'Org(s)',
    DATA_INDEXE: 'Orgs'
  },
  UNITS: {
    TITLE: 'Unit(s)',
    DATA_INDEXE: 'OrgUnits'
  },
  UNIT: {
    TITLE: 'Unit',
    DATA_INDEXE: 'LicensedOrgUnit'
  },
  OHT: {
    TITLE: 'OHT(s)',
    DATA_INDEXE: 'AllowedOhts'
  },
  STAFF_ATM: {
    TITLE: 'Staff ATM',
    DATA_INDEXE: 'SupplementalRoleId'
  },
  ACTION: {
    TITLE: 'Action',
    DATA_INDEXE: 'Actions'
  }
};

export const ColumnsProvider = {
  getFilteredColumns(usersData, singleUnit, currentUserTier, pageMode, orgId, orgName) {
    const columns = [
      {
        title: COLUMN_FIELDS.EMAIL.TITLE,
        dataIndex: COLUMN_FIELDS.EMAIL.DATA_INDEXE,
        sorter: (a, b) => sortAssignedRows(a.key, a.Email, b.Email),
        render: (text, _) => renderDefaultCell(text)
      },
      {
        title: COLUMN_FIELDS.NAME.TITLE,
        dataIndex: COLUMN_FIELDS.NAME.DATA_INDEXE,
        sorter: (a, b) => sortAssignedRows(a.key, a.Name, b.Name),
        render: (text, _) => renderDefaultCell(text)
      },
      {
        title: COLUMN_FIELDS.ROLE.TITLE,
        dataIndex: COLUMN_FIELDS.ROLE.DATA_INDEXE,
        filters: getFilterOptions(usersData, entry => entry.RoleDisplayName),
        onFilter: (value, record) => record.RoleDisplayName === value,
        render: (text, _) => renderDefaultCell(text)
      },
      {
        title: COLUMN_FIELDS.SUPER_USER.TITLE,
        dataIndex: COLUMN_FIELDS.SUPER_USER.DATA_INDEXE,
        sorter: (a, b) => sortAssignedRows(a.key, a.IsSuperUser, b.IsSuperUser),
        render: (_, record, idx) => {
          return (
            <Checkbox
              id={`super-user-checkbox-${singleUnit ? 'ou' : 'org'}-${idx}`}
              data-testid='super-user-checkbox'
              checked={record.IsSuperUser}
              disabled
            />
          );
        },
        hidden: !isUserAdminTier(currentUserTier) || pageMode === PAGE_MODE.ISACAVipOrg
      },
      {
        title: COLUMN_FIELDS.ORGS.TITLE,
        dataIndex: COLUMN_FIELDS.ORGS.DATA_INDEXE,
        sorter: (a, b) => sortAssignedRows(a.key, a.Orgs, b.Orgs),
        render: (text, _) => renderDefaultCell(text),
        hidden: pageMode !== PAGE_MODE.FDAVipOrg
      },
      {
        title: COLUMN_FIELDS.UNITS.TITLE,
        dataIndex: COLUMN_FIELDS.UNITS.DATA_INDEXE,
        sorter: (a, b) => sortAssignedRows(a.key, a.OrgUnits, b.OrgUnits),
        render: (text, _) => renderDefaultCell(text),
        hidden: singleUnit || (pageMode !== PAGE_MODE.FDAVipOrg && pageMode !== PAGE_MODE.MddapOrg)
      },
      {
        title: COLUMN_FIELDS.UNIT.TITLE,
        dataIndex: COLUMN_FIELDS.UNIT.DATA_INDEXE,
        sorter: (a, b) => a.LicensedOrgUnit.localeCompare(b.LicensedOrgUnit),
        filters: getFilterOptions(usersData, entry => entry.LicensedOrgUnit),
        onFilter: (value, record) => record.LicensedOrgUnit === value,
        hidden: !singleUnit
      },
      {
        title: COLUMN_FIELDS.OHT.TITLE,
        dataIndex: COLUMN_FIELDS.OHT.DATA_INDEXE,
        filters: getFilterOptions(usersData, entry => entry.AllowedOhts),
        onFilter: (value, record) => record.AllowedOhts && record.AllowedOhts.includes(value),
        render: (text, _) => renderDefaultCell(text),
        hidden: pageMode !== PAGE_MODE.FDAVipOrg
      },
      {
        title: COLUMN_FIELDS.STAFF_ATM.TITLE,
        dataIndex: COLUMN_FIELDS.STAFF_ATM.DATA_INDEXE,
        sorter: (a, b) => sortAssignedRows(a.key, a.SupplementalRoleId, b.SupplementalRoleId),
        render: (_, record) => {
          return (
            <Checkbox checked={record.SupplementalRoleId === SUPPLEMENTAL_ROLE.ATM} disabled />
          );
        },
        hidden: pageMode !== PAGE_MODE.ISACAVipOrg
      },
      {
        title: COLUMN_FIELDS.ACTION.TITLE,
        dataIndex: COLUMN_FIELDS.ACTION.DATA_INDEXE,
        width: '10%',
        sorter: (a, b) => a.Actions - b.Actions,
        render: (_, record) => (
          <LicensesTableActionButtons
            pageMode={pageMode}
            orgId={orgId}
            orgName={orgName}
            userData={record}
          />
        )
      }
    ];

    const renderDefaultCell = text => {
      if (typeof text === typeof [] && text.length) {
        return text.join(', ');
      }

      if (!text || text.length == 0) {
        return '-';
      }

      return text;
    };

    const filteredColumns = columns.filter(item => !item.hidden);
    return filteredColumns;
  }
};
